import { Icon } from '@/components/icons/svg-icons';
import { inputFieldStyles } from './input-field.style';
import React, { forwardRef } from 'react';

type InputBarProps = {
	icon?: React.ReactNode;
	children?: React.ReactNode;
	className?: string;
	isSuccess?: boolean;
	isError?:boolean;
} & React.ComponentPropsWithRef<'input'>

export const InputFieldBar = forwardRef<HTMLInputElement, InputBarProps>(({
	className,
	isSuccess,
	isError,
	icon,
	children,
	...otherProps 
}, ref) => {
	return (
		<div className={className} data-success={isSuccess} data-error={isError}>
			{icon ? icon : null}
			<input
				className={inputFieldStyles.inputText}
				{...otherProps}
				ref={ref}
			/>
			<Icon name="close-round" className={inputFieldStyles.errorIcon} />
			<Icon name="checkbox-active" className={inputFieldStyles.successIcon} />
			{children ? children : null}
		</div>
	);
});

InputFieldBar.displayName = 'InputFieldBar';
